export default __webpack_public_path__ + "static/media/Groups@32.76190b70.svg";